import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class Accordion {
    constructor() {
        this.accordions = document.querySelectorAll(".js-accordion");
        if (this.accordions.length) {
            // Sofort initialisieren, egal wann die Klasse geladen wurde
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", () => this.init());
            } else {
                this.init();
            }
        }
    }

    slideUp(target, duration = 500) {
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + "ms";
        target.style.boxSizing = "border-box";
        target.style.height = target.offsetHeight + "px";
        target.offsetHeight; // reflow
        target.style.overflow = "hidden";
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(() => {
            target.style.display = "none";
            target.style.removeProperty("height");
            target.style.removeProperty("padding-top");
            target.style.removeProperty("padding-bottom");
            target.style.removeProperty("margin-top");
            target.style.removeProperty("margin-bottom");
            target.style.removeProperty("overflow");
            target.style.removeProperty("transition-duration");
            target.style.removeProperty("transition-property");
        }, duration);
    }

    slideDown(target, duration = 500) {
        target.style.removeProperty("display");
        let display = window.getComputedStyle(target).display;
        if (display === "none") display = "block";
        target.style.display = display;

        const height = target.offsetHeight;
        target.style.overflow = "hidden";
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight; // reflow
        target.style.boxSizing = "border-box";
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + "ms";
        target.style.height = height + "px";
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        window.setTimeout(() => {
            target.style.removeProperty("height");
            target.style.removeProperty("overflow");
            target.style.removeProperty("transition-duration");
            target.style.removeProperty("transition-property");
        }, duration);
    }

    init() {
        // Optional: Event Delegation macht es robust gegen dynamische Inhalte
        this.accordions.forEach((accordion) => {
            accordion.addEventListener("click", (e) => {
                const accordionHeader = e.target.closest(".js-accordion-head");
                if (!accordionHeader || !accordion.contains(accordionHeader)) return;

                const accordionContent = accordionHeader
                    .closest(".js-accordion-item")
                    .querySelector(".js-accordion-content");

                if (accordionHeader.classList.contains("is-active")) {
                    accordionHeader.classList.remove("is-active");
                    accordionContent.classList.remove("is-open");
                    this.slideUp(accordionContent);
                } else {
                    const openElement = accordion.querySelector(".js-accordion-content.is-open");
                    if (openElement) {
                        openElement.classList.remove("is-open");
                        this.slideUp(openElement);
                    }
                    const activeElement = accordion.querySelector(".js-accordion-head.is-active");
                    if (activeElement) activeElement.classList.remove("is-active");

                    accordionHeader.classList.add("is-active");
                    accordionContent.classList.add("is-open");
                    this.slideDown(accordionContent);
                }

                setTimeout(() => ScrollTrigger.refresh(), 500); // Zahl statt String
            });
        });

        // Hash-Open direkt beim Start behandeln
        this.openFromHash();
    }

    openFromHash() {
        const hash = window.location.hash;
        if (!hash) return;

        const target = document.querySelector(hash);
        if (!target) return;

        const accordionBox = target.closest(".js-accordion-item");
        if (!accordionBox) return;

        const accordion = accordionBox.closest(".js-accordion");
        const accordionHead = accordionBox.querySelector(".js-accordion-head");
        const accordionContent = accordionBox.querySelector(".js-accordion-content");

        const openElement = accordion.querySelector(".js-accordion-content.is-open");
        if (openElement && openElement !== accordionContent) {
            openElement.classList.remove("is-open");
            this.slideUp(openElement);
        }
        const activeElement = accordion.querySelector(".js-accordion-head.is-active");
        if (activeElement && activeElement !== accordionHead) {
            activeElement.classList.remove("is-active");
        }

        accordionHead.classList.add("is-active");
        accordionContent.classList.add("is-open");
        this.slideDown(accordionContent);

        setTimeout(() => {
            ScrollTrigger.refresh();
            // target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 500);
    }
}

export default Accordion;
